import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Slider from "react-slick";

import Layout from '../../components/Layout';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Result = (props) => {

  const [logs, setLogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return; // Or redirect

      const response = await axios.get('/api/challenge/results', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLogs(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.2,
    slidesToScroll: 1,
    swipeToSlide: true,
    touchThreshold: 50,
  };


  const sliderLogs = logs.slice(0, 5);
  const listLogs = logs.slice(5);

  return (
    <Layout header={{ title: '챌린지 결과', Backbtn: true, link: '/Main' }} containName='result'>

      <div className="result-wrap today">
        <strong>Recent</strong>

        {sliderLogs.length > 0 ? (
          <Slider {...settings}>
            {sliderLogs.map(log => (
              <div className='result-item' key={log.id}>
                <Link to={`/Challenge/Detail?id=${log.id}`}>
                  <p className="date">{new Date(log.created_at).toLocaleDateString()}</p>
                  <strong className="number">{log.score}</strong>
                  <div className="length">
                    <div className="answer">
                      <p>정답수</p>
                      {log.score === log.total && <span className="perfect">PERFECT</span>}
                      <p className="count">{log.score}</p>
                    </div>
                    <div className="incorrect">
                      <p>오답수</p>
                      <p className="count">{log.wrong_count}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        ) : (
          <p className="no-data" style={{ padding: '20px', color: '#999' }}>최근 기록이 없습니다.</p>
        )}
      </div>

      <div className="result-wrap record">
        <strong>Past Records</strong>
        <ul className="result-list">
          {listLogs.map(log => (
            <li key={log.id}>
              <Link to={`/Challenge/Detail?id=${log.id}`}>
                <p className="date">{new Date(log.created_at).toLocaleDateString()}</p>
                <strong className="number">{log.score}</strong>
                <div className="length">
                  <div className="answer">
                    <p>정답수</p>
                    <p className="count">{log.score}</p>
                  </div>
                  <div className="incorrect">
                    <p>오답수</p>
                    <p className="count">{log.wrong_count}</p>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>

    </Layout>
  );
};

export default Result;